import 'jquery-validation';
import {showButtonLoader, hideButtonLoader, isStrongPassword, getStrongPasswordErrorMessage} from '../../util/helpers';

export default {
  init: function () {

    var accountForm = $('#accountForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);

      setTimeout(() => {
        var valid = accountForm.valid();
        if (valid) {
          setTimeout(function () {
            accountForm.submit();
          }, 1000);
        } else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

    $.validator.addMethod("passwordCustomRules", function(value) {
      // Don't fire up if the user didn't add the password
      if (value.length < 1) {
        return true;
      }

      return isStrongPassword(value);
    }, getStrongPasswordErrorMessage);

    accountForm.validate({
      errorElement: "span",
      rules: {
        email: {
          required: true,
        },
        password: {
          passwordCustomRules: true,
          required: false,
        },
        password2: {
          equalTo: "#inputPassword",
          required: function () {
            return $("#inputPassword").val().length > 0;
          },
        },
      },
    });

    $.uploadPreview({
      input_field: "#profile-image-upload",
      preview_box: "#profile-image-preview",
      label_field: "#profile-image-label",
      label_default: "Profile Image",
      label_selected: "Change Image",
      error_selector: ".profile-image-error",
    });

    /**
     * Toggle password type to view password
     */
    const inputPassword = $('.mb-account-change__password input');
    const inputRePassword = $('#inputRePassword');
    $('.mb-account-change__eye').click(function () {
      function changeInputTypeToText(input) {
        if (input.attr('type') === 'text') {
          input.attr('type', 'password');
        } else {
          input.attr('type', 'text');
        }
      }

      changeInputTypeToText(inputPassword);
      changeInputTypeToText(inputRePassword);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/account.js